import { put, takeLatest } from 'redux-saga/effects'

import { companyModule } from '../modules'
import { fetchCompany } from '../apiModules/company'

function* fetchCompanySaga(action) {
  yield put(companyModule.fetchLoading(true))
  const response = yield fetchCompany(action.payload)
  yield put(companyModule.fetchSuccess(response))
}

export default function* watchCompanySaga() {
  yield takeLatest(companyModule.FETCH, fetchCompanySaga)
}
